import request from '@/utils/request'

export function getXmzlList(data) {
  return request({
    url: '/api/Extend/LqXmzl',
    method: 'get',
    data
  })
}

export function getXmzlInfo(id) {
  return request({
    url: `/api/Extend/LqXmzl/${id}`,
    method: 'get'
  })
}
